/** Shared listing photo / video limits (keep in sync with server s3Presign). */

export const MIN_LISTING_PHOTOS = 3;
export const MAX_LISTING_PHOTOS = 48;
export const MAX_LISTING_VIDEOS = 3;
export const MAX_VIDEO_SECONDS = 60;
export const MAX_VIDEO_BYTES = 100 * 1024 * 1024; // 100MB
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024; // 10MB

export const ACCEPTED_VIDEO_MIME_TYPES = ["video/mp4", "video/webm"] as const;
export const ACCEPTED_VIDEO_ACCEPT = "video/mp4,video/webm,.mp4,.webm";
